import { ChargingDepartments } from '../../features/AdminPages/Clients/Dialogs/CreateEditDialog/CreateEditDialog.functions';
import { Address } from '../address';
import { PaginationQueryParams, WithPagination } from '../api';
import { Numeric } from '../general';

// GET /clients
export type ClientCollection = WithPagination<
  {
    id: number;
    korisnik_id: number;
    ime: string;
    email: string | null;
    mesto_id: number | null;
    mesto_ime: string | null;
    opstina_id: number | null;
    opstina_ime: string | null;
    ulica_id: number | null;
    telefon: string | null;
    mobilen: string | null;
    adresa: string | null;
    broj: string | null;
    vlez: string | null;
    stan: string | null;
    address: Address;
  }[]
>;

// GET /clients/:id
export type ClientResource = {
  id: number;
  korisnik_id: number;
  ime: string;
  mesto_id: number | null;
  mesto_ime: string | null;
  opstina_id: number | null;
  opstina_ime: string | null;
  ulica_id: number | null;
  street_name: string | null;
  broj: string | null;
  vlez: string | null;
  stan: string | null;
  mobilen: string | null;
  faktura: number | null;
  status_id: number;
  telefon: string | null;
  adresa: string | null;
  direkcija_id: number | null;
  direkcija_ime: string;
  cenovnik_id?: number | null;
  same_price_list_for_subsidiaries?: number | null;
  pravno_lice?: number | null;
  dejnost_id?: number;
  web?: string | null;
  odgovorno_lice?: string | null;
  kontakt_lice?: string | null;
  referenca?: string | null;
  reference_name?: string | null;
  komentar?: string | null;
  danocen_broj?: string | null;
  smetka?: string | null;
  maticen_broj?: string | null;
  broj_dogovor?: string | null;
  email?: string | null;
  rok_plakanje?: number | null;
  sms_gateway?: string | null;
  interen_klient?: number | null;
  cod_department_id?: number | null;
  invoice_department_id?: number | null;
  cod_bank_account_payment?: number | null;
  allow_incomplete_address?: number | null;
  proof_of_delivery?: number | null;
  orders_on_map_access?: number | null;
  import_notification?: number | null;
  cod_email_warrant?: number | null;
  invoice_email_warrant?: number | null;
  import_list_types?: { id: number; name: string }[] | null;
  rabotno_vreme?: string | null;
  email_configuration?: any | null;
  recipient_pricelist_id?: number | null;
  address: Address;
  notification: Notifications[];
  departments: ChargingDepartments[];
  popust: Discounts[];
  invoice_date_basis_type_id?: number | null;
};

export type Discounts = {
  Popust: string;
  UslugaId: string;
  ProizvodId: string;
};

export type Notifications = {
  channel: number;
  actor: number;
  event: number;
};

// GET /clients/invoiceable
export type InvoiceableCollection = WithPagination<
  {
    id: number;
    ime: string;
  }[]
>;

// GET /clients/invoiced
export type InvoicedCollection = WithPagination<
  {
    id: number;
    ime: string;
  }[]
>;

// GET /clients/lookup
export type ClientLookupCollection = WithPagination<
  {
    id: number;
    korisnik_id: number;
    ime: string;
    email: string | null;
    mesto_id: number | null;
    mesto_ime: string | null;
    opstina_id: number | null;
    opstina_ime: string | null;
    ulica_id: number | null;
    telefon: string | null;
    mobilen: string | null;
    adresa: string | null;
    broj: string | null;
    vlez: string | null;
    stan: string | null;
    address: Address;
  }[]
>;

// GET /clients/:id/importlists/types
export type ClientImportListTypeCollection = {
  id: number;
  name: string;
}[];

// ---------- Query params ---------- //
export type ClientLookupCollectionQueryParams = PaginationQueryParams<{
  id?: Numeric | Numeric[];
  ime?: string;
}>;

// ---------- Query params ---------- //
export enum ClientsCollectionGroupRoleFilter {
  Headquarter = 'headquarter',
  Subsidiary = 'subsidiary',
}
